import React, { useState } from 'react';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import PurchasesReports from '../components/reports/PurchasesReports';
import QuotesReports from '../components/reports/QuotesReports';
import ReportsNavbar from '../components/reports/ReportsNavbar';
import CardHeadeWithActions from '../components/ui/CardHeadeWithActions';

const Reports = () => {
    const [tabActive, setTabActive] = useState('SalesReport');
    const [t] = useTranslation('global');

    const tabs = [
        {
            id: 'SalesReport',
            label: t('reports.sales_Report'),
            component: <PurchasesReports />,
        },
        {
            id: 'requisition_report',
            label: t('reports.requisition_Report'),
            component: <QuotesReports />,
        },
    ];

    const activeTab = tabs.find((tab) => tab.id === tabActive) || tabs[0];

    return (
        <div className='overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm'>
            <CardHeadeWithActions
                title={t('reports.reports')}
                icon={<HiOutlineDocumentReport size={22} />}
            >
                <span className='rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-500'>
                    {activeTab.label}
                </span>
            </CardHeadeWithActions>

            <div className='bg-slate-50 p-3 md:p-4'>
                <ReportsNavbar tabActive={tabActive} setTabActive={setTabActive} />

                <div className='pt-4'>
                    {tabs.map((tab) => (
                        <section
                            key={tab.id}
                            id={tab.id}
                            className={tabActive === tab.id ? 'block' : 'hidden'}
                        >
                            {tab.component}
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Reports;
